// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ServiceForm.css — estilos de la ficha de servicio que no son del sistema dv-*.
 *
 * De momento solo la lista de "Relaciones del modelo" de la pestaña
 * Dependencias: el bloque que enseña los enlaces creados en el Diseñador
 * (servicio → servicio y servicio → equipo), que antes no se veían en la ficha.
 *
 * Todo va con variables del sistema de diseño para que los skins lo sigan.
 */

#sf-relaciones-modelo {
  border-left: 3px solid #8b5cf6;
}

#sf-relaciones-modelo .dv-section-title {
  color: var(--text-primary);
}

.sf-rel-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

@media (max-width: 900px) {
  .sf-rel-grid { grid-template-columns: minmax(0, 1fr); }
}

.sf-rel-head {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--text-muted);
  padding-bottom: 6px;
  margin-bottom: 8px;
  border-bottom: 1px solid var(--border);
}

.sf-rel-empty {
  font-size: 0.82rem;
  font-style: italic;
  color: var(--text-muted);
}

.sf-rel-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 6px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-card);
  font-size: 0.85rem;
}

.sf-rel-icon {
  font-size: 1.05rem;
  line-height: 1;
}

.sf-rel-arrow {
  color: #8b5cf6;
  font-weight: 700;
}

.sf-rel-type {
  font-size: 0.74rem;
  font-weight: 700;
  color: #8b5cf6;
  background: rgba(139, 92, 246, 0.12);
  border-radius: 999px;
  padding: 2px 9px;
  white-space: nowrap;
}

.sf-rel-target {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.sf-rel-link {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-weight: 700;
  color: var(--accent);
  cursor: pointer;
  text-align: left;
}

.sf-rel-link:hover {
  text-decoration: underline;
}

.sf-rel-plain {
  font-weight: 600;
  color: var(--text-primary);
}

/* ── Alojamiento del servicio ─────────────────────────────────────────────── */
.sf-hosting-hero {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  margin-bottom: 1.25rem;
  border: 1px solid var(--border);
  border-left: 3px solid var(--accent);
  border-radius: 12px;
  background: var(--bg-card);
}
.sf-hosting-hero-icon {
  width: 42px;
  height: 42px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--bg-toolbar);
  color: var(--accent);
}
.sf-hosting-hero-icon svg { width: 22px; height: 22px; }
.sf-hosting-hero-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}
.sf-hosting-hero p {
  margin: 4px 0 0;
  max-width: 760px;
  font-size: 0.82rem;
  line-height: 1.45;
  color: var(--text-muted);
}

.sf-hosting-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 10px;
}
.sf-hosting-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.sf-hosting-card:hover { border-color: var(--accent); background: var(--bg-toolbar); }
.sf-hosting-card.active {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.08);
  box-shadow: inset 0 0 0 1px var(--accent);
}
.sf-hosting-card:disabled { cursor: default; opacity: 1; }
.sf-hosting-card-icon {
  width: 34px;
  height: 34px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--bg-toolbar);
  color: var(--accent);
}
.sf-hosting-card-icon svg { width: 18px; height: 18px; }
.sf-hosting-card-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  padding-right: 14px;
}
.sf-hosting-card-label {
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--text-primary);
}
.sf-hosting-card-desc {
  font-size: 0.74rem;
  line-height: 1.35;
  color: var(--text-muted);
}
.sf-hosting-card-check {
  position: absolute;
  top: 9px;
  right: 9px;
  width: 16px;
  height: 16px;
  color: var(--accent);
}

.sf-hosting-sub {
  margin: -2px 0 12px;
  font-size: 0.8rem;
  color: var(--text-muted);
}
.sf-hosting-external {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
}
.sf-hosting-external > svg { width: 24px; height: 24px; flex: none; color: var(--accent); }
.sf-hosting-external > div { flex: 1 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.sf-hosting-external strong { font-size: 0.86rem; color: var(--text-primary); }
.sf-hosting-external span { font-size: 0.78rem; color: var(--text-muted); }
.sf-hosting-external .dv-btn { display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }
.sf-hosting-external .dv-btn svg { width: 13px; height: 13px; }

.sf-hosting-related {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 10px;
  margin-top: 1rem;
}
.sf-hosting-related-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.sf-hosting-related-card:hover { border-color: var(--accent); background: var(--bg-toolbar); }
.sf-hosting-related-card > svg { width: 20px; height: 20px; flex: none; color: var(--accent); }
.sf-hosting-related-card > span { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.sf-hosting-related-card strong { font-size: 0.82rem; color: var(--text-primary); }
.sf-hosting-related-card small { font-size: 0.73rem; color: var(--text-muted); }

/* Equipos asociados */
.sf-hosts-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.sf-hosts-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
}
.sf-hosts-count svg { width: 16px; height: 16px; color: var(--accent); }
.sf-hosts-hint { margin-top: 2px; font-size: 0.74rem; color: var(--text-muted); }
.sf-hosts-add { display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }
.sf-hosts-add svg { width: 14px; height: 14px; }

.sf-hosts-list { display: grid; gap: 8px; margin-top: 12px; }
.sf-host-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
}
.sf-host-item-icon {
  width: 32px;
  height: 32px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--bg-toolbar);
  color: var(--accent);
}
.sf-host-item-icon svg { width: 16px; height: 16px; }
.sf-host-item-body { flex: 1 1; min-width: 0; }
.sf-host-item-name { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); }
.sf-host-item-meta { font-size: 0.72rem; color: var(--text-muted); }
.sf-host-role {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(var(--accent-rgb), 0.1);
  color: var(--accent);
  font-size: 0.68rem;
  font-weight: 700;
  white-space: nowrap;
}
.sf-host-remove {
  flex: none;
  padding: 4px;
  border: 0;
  border-radius: 6px;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
}
.sf-host-remove:hover { color: #ef4444; background: rgba(239, 68, 68, 0.1); }
.sf-host-remove svg { width: 14px; height: 14px; }

.sf-hosts-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin-top: 12px;
  padding: 24px 18px;
  border: 1px dashed var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  text-align: center;
}
.sf-hosts-empty-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3px;
  border-radius: 12px;
  background: var(--bg-toolbar);
  color: var(--text-muted);
}
.sf-hosts-empty-icon svg { width: 20px; height: 20px; }
.sf-hosts-empty strong { font-size: 0.86rem; color: var(--text-primary); }
.sf-hosts-empty span { max-width: 420px; font-size: 0.78rem; line-height: 1.4; color: var(--text-muted); }
.sf-hosts-empty .dv-btn { display: inline-flex; align-items: center; gap: 5px; margin-top: 6px; }
.sf-hosts-empty .dv-btn svg { width: 13px; height: 13px; }

/* Formulario de alta de equipo */
.sf-host-form {
  margin-top: 12px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-toolbar);
}
.sf-host-form-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}
.sf-host-form-head > div { display: flex; flex-direction: column; gap: 2px; }
.sf-host-form-head strong { font-size: 0.86rem; color: var(--text-primary); }
.sf-host-form-head span { font-size: 0.74rem; color: var(--text-muted); }
.sf-host-form-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: 0;
  border-radius: 6px;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
}
.sf-host-form-close:hover { color: var(--text-primary); background: var(--bg-card); }
.sf-host-form-close svg { width: 15px; height: 15px; }

.sf-host-form-grid {
  display: grid;
  grid-template-columns: minmax(160px, 0.8fr) minmax(220px, 1.2fr) auto;
  gap: 10px;
  align-items: end;
}
@media (max-width: 800px) { .sf-host-form-grid { grid-template-columns: 1fr; } }
.sf-host-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--text-secondary);
}
.sf-host-field-search { min-width: 0; }
.sf-host-browse-btn { display: inline-flex; align-items: center; gap: 4px; height: 31px; white-space: nowrap; }
.sf-host-browse-btn svg { width: 12px; height: 12px; }
.sf-host-form-hint { margin: 8px 0 0; font-size: 0.72rem; color: var(--text-muted); }
.sf-host-form-actions {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.sf-host-field-role { width: 220px; max-width: 100%; }
.sf-host-form-buttons { display: flex; gap: 6px; margin-left: auto; }

/* Selector de equipos del inventario */
.sf-browse-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.55);
}
.sf-browse-modal {
  display: flex;
  flex-direction: column;
  width: 640px;
  max-width: 100%;
  max-height: 80vh;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: var(--bg-card);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}
.sf-browse-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
}
.sf-browse-head > div { display: flex; flex-direction: column; gap: 2px; }
.sf-browse-head strong { font-size: 0.92rem; color: var(--text-primary); }
.sf-browse-head span { font-size: 0.75rem; color: var(--text-muted); }
.sf-browse-filter { padding: 10px 16px; border-bottom: 1px solid var(--border); }
.sf-browse-list { flex: 1 1; overflow-y: auto; min-height: 200px; }
.sf-browse-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px 16px;
  border: 0;
  border-bottom: 1px solid var(--border);
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.sf-browse-item:hover:not(:disabled) { background: var(--bg-toolbar); }
.sf-browse-item.is-selected { background: rgba(var(--accent-rgb), 0.08); }
.sf-browse-item.is-added { opacity: 0.5; cursor: not-allowed; }
.sf-browse-item-icon { font-size: 1.2rem; }
.sf-browse-item-body { display: flex; flex-direction: column; gap: 2px; flex: 1 1; min-width: 0; }
.sf-browse-item-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); }
.sf-browse-item-desc { font-size: 0.74rem; color: var(--text-muted); }
.sf-browse-item-added { font-size: 0.72rem; font-weight: 600; color: #16a34a; }
.sf-browse-empty { padding: 30px 20px; text-align: center; font-size: 0.84rem; color: var(--text-muted); }

.sf-rel-kind {
  font-size: 0.68rem;
  color: var(--text-muted);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 0 5px;
  white-space: nowrap;
}

/* ── Dependencias unificadas: necesita vs impacto ───────────────────────── */
.sf-dep-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.sf-dep-lead {
  max-width: 760px;
  margin: 4px 0 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: var(--text-muted);
}
.sf-dep-head-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }

.sf-dep-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}
.sf-dep-summary-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
}
.sf-dep-summary-card span {
  font-size: 0.67rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}
.sf-dep-summary-card strong { font-size: 1.15rem; color: var(--text-primary); }
.sf-dep-summary-need strong { color: #f59e0b; }
.sf-dep-summary-impact strong { color: #a78bfa; }

.sf-dep-form {
  margin-bottom: 16px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-toolbar);
}
.sf-dep-form-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}
.sf-dep-form-head > div { display: flex; flex-direction: column; gap: 2px; }
.sf-dep-form-head strong { font-size: 0.86rem; color: var(--text-primary); }
.sf-dep-form-head span { font-size: 0.74rem; color: var(--text-muted); }
.sf-dep-form-grid {
  display: grid;
  grid-template-columns: minmax(150px, 0.9fr) minmax(220px, 1.4fr) minmax(120px, 0.6fr);
  gap: 10px;
  align-items: end;
}
@media (max-width: 900px) { .sf-dep-form-grid { grid-template-columns: 1fr; } }
.sf-dep-form-notes { margin-top: 10px; }
.sf-dep-form-actions { display: flex; gap: 6px; margin-top: 12px; }

.sf-dep-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 900px) { .sf-dep-columns { grid-template-columns: 1fr; } }
.sf-dep-column {
  min-width: 0;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
}
.sf-dep-col-head { display: flex; align-items: center; gap: 8px; }
.sf-dep-col-head strong { font-size: 0.88rem; color: var(--text-primary); }
.sf-dep-col-dot {
  width: 8px;
  height: 8px;
  flex: none;
  border-radius: 50%;
  background: #f59e0b;
}
.sf-dep-column-impact .sf-dep-col-dot { background: #a78bfa; }
.sf-dep-col-count {
  margin-left: auto;
  padding: 1px 8px;
  border-radius: 999px;
  background: var(--bg-toolbar);
  color: var(--text-muted);
  font-size: 0.72rem;
  font-weight: 700;
}
.sf-dep-col-sub { margin: 2px 0 10px; font-size: 0.75rem; color: var(--text-muted); }

.sf-dep-row {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 7px;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: var(--bg-card);
}
.sf-dep-row-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: none;
  border-radius: 8px;
  background: var(--bg-toolbar);
  font-size: 15px;
}
.sf-dep-row-body { flex: 1 1; min-width: 0; }
.sf-dep-row-title {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-primary);
}
.sf-dep-link {
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}
.sf-dep-link:hover { text-decoration: underline; }
.sf-dep-source {
  padding: 1px 6px;
  border: 1px solid var(--border);
  border-radius: 999px;
  color: var(--text-muted);
  font-size: 0.63rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.sf-dep-source.is-model { color: #a78bfa; border-color: rgba(139, 92, 246, 0.4); }
.sf-dep-row-meta {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 3px;
  font-size: 0.72rem;
  color: var(--text-muted);
}
.sf-dep-note {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: italic;
}
.sf-dep-empty {
  margin-top: 8px;
  padding: 16px 12px;
  border: 1px dashed var(--border);
  border-radius: 9px;
  color: var(--text-muted);
  font-size: 0.78rem;
  text-align: center;
}
.sf-dep-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  padding: 4px;
  border: 0;
  border-radius: 6px;
  background: none;
  color: var(--text-muted);
  cursor: pointer;
}
.sf-dep-remove:hover { color: #ef4444; background: rgba(239, 68, 68, 0.1); }
.sf-dep-remove svg { width: 14px; height: 14px; }
.sf-dep-footnote { margin: 10px 0 0; font-size: 0.72rem; color: var(--text-muted); }

/* ── Elementos del servicio (miembros del Disenador) ────────────────────────
   Lista de CIs que forman el servicio con su papel, para no depender del canvas. */
#sf-elementos-servicio {
  border-left: 3px solid var(--accent);
}

.sf-el-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sf-el-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px dashed var(--border);
}

.sf-el-row:last-child { border-bottom: none; }

.sf-el-name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.82rem;
  color: var(--text-primary);
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
}

.sf-el-detail {
  font-size: 0.74rem;
  color: var(--text-muted);
}

.sf-el-role {
  flex: 0 0 auto;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--accent);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 1px 8px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServiceForm.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,eAAe,qCAAqC,EAAE;AACxD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA,4BAA4B,WAAW,EAAE,YAAY,EAAE;AACvD;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA,yBAAyB,2BAA2B,EAAE,6BAA6B,EAAE;AACrF;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,yCAAyC;AAC3C;AACA,4BAA4B,eAAe,EAAE,UAAU,EAAE;AACzD;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA,4BAA4B,WAAW,EAAE,YAAY,EAAE;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,6BAA6B,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,oBAAoB,EAAE;AAC1F,6BAA6B,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACrG,8BAA8B,kBAAkB,EAAE,0BAA0B,EAAE;AAC9E,4BAA4B,kBAAkB,EAAE,wBAAwB,EAAE;AAC1E,+BAA+B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACzG,mCAAmC,WAAW,EAAE,YAAY,EAAE;;AAE9D;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,iCAAiC,2BAA2B,EAAE,6BAA6B,EAAE;AAC7F,iCAAiC,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,oBAAoB,EAAE;AAC9F,kCAAkC,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACjG,kCAAkC,kBAAkB,EAAE,0BAA0B,EAAE;AAClF,iCAAiC,kBAAkB,EAAE,wBAAwB,EAAE;;AAE/E,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE;AACvE,iBAAiB,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAChF,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC1F,oBAAoB,WAAW,EAAE,YAAY,EAAE;;AAE/C,iBAAiB,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA,yBAAyB,WAAW,EAAE,YAAY,EAAE;AACpD,qBAAqB,SAAO,EAAE,YAAY,EAAE;AAC5C,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACvF,qBAAqB,kBAAkB,EAAE,wBAAwB,EAAE;AACnE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA,wBAAwB,cAAc,EAAE,kCAAkC,EAAE;AAC5E,sBAAsB,WAAW,EAAE,YAAY,EAAE;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA,2BAA2B,WAAW,EAAE,YAAY,EAAE;AACtD,yBAAyB,kBAAkB,EAAE,0BAA0B,EAAE;AACzE,uBAAuB,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;AACzG,0BAA0B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAChG,8BAA8B,WAAW,EAAE,YAAY,EAAE;;AAEzD,iCAAiC;AACjC;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,2BAA2B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC5E,4BAA4B,kBAAkB,EAAE,0BAA0B,EAAE;AAC5E,0BAA0B,kBAAkB,EAAE,wBAAwB,EAAE;AACxE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA,4BAA4B,0BAA0B,EAAE,0BAA0B,EAAE;AACpF,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD;EACE,aAAa;EACb,qEAAqE;EACrE,SAAS;EACT,gBAAgB;AAClB;AACA,4BAA4B,qBAAqB,0BAA0B,EAAE,EAAE;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,wBAAwB,YAAY,EAAE;AACtC,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC9G,0BAA0B,WAAW,EAAE,YAAY,EAAE;AACrD,qBAAqB,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AACpF;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA,sBAAsB,YAAY,EAAE,eAAe,EAAE;AACrD,wBAAwB,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE;;AAEpE,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;AACA,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzE,yBAAyB,kBAAkB,EAAE,0BAA0B,EAAE;AACzE,uBAAuB,kBAAkB,EAAE,wBAAwB,EAAE;AACrE,oBAAoB,kBAAkB,EAAE,sCAAsC,EAAE;AAChF,kBAAkB,SAAO,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sCAAsC;EACtC,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,uCAAuC,6BAA6B,EAAE;AACtE,8BAA8B,yCAAyC,EAAE;AACzE,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D,uBAAuB,iBAAiB,EAAE;AAC1C,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO,EAAE,YAAY,EAAE;AAC/F,uBAAuB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACzF,uBAAuB,kBAAkB,EAAE,wBAAwB,EAAE;AACrE,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9E,mBAAmB,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAEzG;EACE,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEtF;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA,8BAA8B,kBAAkB,EAAE,0BAA0B,EAAE;AAC9E,8BAA8B,cAAc,EAAE;AAC9C,gCAAgC,cAAc,EAAE;;AAEhD;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3E,2BAA2B,kBAAkB,EAAE,0BAA0B,EAAE;AAC3E,yBAAyB,kBAAkB,EAAE,wBAAwB,EAAE;AACvE;EACE,aAAa;EACb,qFAAqF;EACrF,SAAS;EACT,gBAAgB;AAClB;AACA,4BAA4B,oBAAoB,0BAA0B,EAAE,EAAE;AAC9E,qBAAqB,gBAAgB,EAAE;AACvC,uBAAuB,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAElE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;AAC5E;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACjE,0BAA0B,kBAAkB,EAAE,0BAA0B,EAAE;AAC1E;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA,wCAAwC,mBAAmB,EAAE;AAC7D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,kBAAkB,kBAAkB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAEpF;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;AACA,mBAAmB,SAAO,EAAE,YAAY,EAAE;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA,qBAAqB,0BAA0B,EAAE;AACjD;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,0BAA0B,cAAc,EAAE,qCAAqC,EAAE;AACjF;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA,uBAAuB,cAAc,EAAE,kCAAkC,EAAE;AAC3E,qBAAqB,WAAW,EAAE,YAAY,EAAE;AAChD,mBAAmB,gBAAgB,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;;AAEnF;mFACmF;AACnF;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,uCAAuC;AACzC;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/**\r\n * ServiceForm.css — estilos de la ficha de servicio que no son del sistema dv-*.\r\n *\r\n * De momento solo la lista de \"Relaciones del modelo\" de la pestaña\r\n * Dependencias: el bloque que enseña los enlaces creados en el Diseñador\r\n * (servicio → servicio y servicio → equipo), que antes no se veían en la ficha.\r\n *\r\n * Todo va con variables del sistema de diseño para que los skins lo sigan.\r\n */\r\n\r\n#sf-relaciones-modelo {\r\n  border-left: 3px solid #8b5cf6;\r\n}\r\n\r\n#sf-relaciones-modelo .dv-section-title {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sf-rel-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 18px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .sf-rel-grid { grid-template-columns: minmax(0, 1fr); }\r\n}\r\n\r\n.sf-rel-head {\r\n  font-size: 0.78rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: var(--text-muted);\r\n  padding-bottom: 6px;\r\n  margin-bottom: 8px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.sf-rel-empty {\r\n  font-size: 0.82rem;\r\n  font-style: italic;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sf-rel-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  margin-bottom: 6px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-card);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sf-rel-icon {\r\n  font-size: 1.05rem;\r\n  line-height: 1;\r\n}\r\n\r\n.sf-rel-arrow {\r\n  color: #8b5cf6;\r\n  font-weight: 700;\r\n}\r\n\r\n.sf-rel-type {\r\n  font-size: 0.74rem;\r\n  font-weight: 700;\r\n  color: #8b5cf6;\r\n  background: rgba(139, 92, 246, 0.12);\r\n  border-radius: 999px;\r\n  padding: 2px 9px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.sf-rel-target {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  min-width: 0;\r\n}\r\n\r\n.sf-rel-link {\r\n  border: none;\r\n  background: none;\r\n  padding: 0;\r\n  font: inherit;\r\n  font-weight: 700;\r\n  color: var(--accent);\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.sf-rel-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.sf-rel-plain {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* ── Alojamiento del servicio ─────────────────────────────────────────────── */\r\n.sf-hosting-hero {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 14px;\r\n  padding: 16px 18px;\r\n  margin-bottom: 1.25rem;\r\n  border: 1px solid var(--border);\r\n  border-left: 3px solid var(--accent);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n}\r\n.sf-hosting-hero-icon {\r\n  width: 42px;\r\n  height: 42px;\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 12px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--accent);\r\n}\r\n.sf-hosting-hero-icon svg { width: 22px; height: 22px; }\r\n.sf-hosting-hero-title {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n.sf-hosting-hero p {\r\n  margin: 4px 0 0;\r\n  max-width: 760px;\r\n  font-size: 0.82rem;\r\n  line-height: 1.45;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sf-hosting-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\r\n  gap: 10px;\r\n}\r\n.sf-hosting-card {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  padding: 12px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  color: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s, background 0.15s;\r\n}\r\n.sf-hosting-card:hover { border-color: var(--accent); background: var(--bg-toolbar); }\r\n.sf-hosting-card.active {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n  box-shadow: inset 0 0 0 1px var(--accent);\r\n}\r\n.sf-hosting-card:disabled { cursor: default; opacity: 1; }\r\n.sf-hosting-card-icon {\r\n  width: 34px;\r\n  height: 34px;\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 10px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--accent);\r\n}\r\n.sf-hosting-card-icon svg { width: 18px; height: 18px; }\r\n.sf-hosting-card-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  min-width: 0;\r\n  padding-right: 14px;\r\n}\r\n.sf-hosting-card-label {\r\n  font-size: 0.86rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n.sf-hosting-card-desc {\r\n  font-size: 0.74rem;\r\n  line-height: 1.35;\r\n  color: var(--text-muted);\r\n}\r\n.sf-hosting-card-check {\r\n  position: absolute;\r\n  top: 9px;\r\n  right: 9px;\r\n  width: 16px;\r\n  height: 16px;\r\n  color: var(--accent);\r\n}\r\n\r\n.sf-hosting-sub {\r\n  margin: -2px 0 12px;\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n}\r\n.sf-hosting-external {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n}\r\n.sf-hosting-external > svg { width: 24px; height: 24px; flex: none; color: var(--accent); }\r\n.sf-hosting-external > div { flex: 1; display: flex; flex-direction: column; gap: 2px; min-width: 0; }\r\n.sf-hosting-external strong { font-size: 0.86rem; color: var(--text-primary); }\r\n.sf-hosting-external span { font-size: 0.78rem; color: var(--text-muted); }\r\n.sf-hosting-external .dv-btn { display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }\r\n.sf-hosting-external .dv-btn svg { width: 13px; height: 13px; }\r\n\r\n.sf-hosting-related {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n  gap: 10px;\r\n  margin-top: 1rem;\r\n}\r\n.sf-hosting-related-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  color: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n.sf-hosting-related-card:hover { border-color: var(--accent); background: var(--bg-toolbar); }\r\n.sf-hosting-related-card > svg { width: 20px; height: 20px; flex: none; color: var(--accent); }\r\n.sf-hosting-related-card > span { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\r\n.sf-hosting-related-card strong { font-size: 0.82rem; color: var(--text-primary); }\r\n.sf-hosting-related-card small { font-size: 0.73rem; color: var(--text-muted); }\r\n\r\n/* Equipos asociados */\r\n.sf-hosts-toolbar {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n.sf-hosts-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n.sf-hosts-count svg { width: 16px; height: 16px; color: var(--accent); }\r\n.sf-hosts-hint { margin-top: 2px; font-size: 0.74rem; color: var(--text-muted); }\r\n.sf-hosts-add { display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }\r\n.sf-hosts-add svg { width: 14px; height: 14px; }\r\n\r\n.sf-hosts-list { display: grid; gap: 8px; margin-top: 12px; }\r\n.sf-host-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n}\r\n.sf-host-item-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 9px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--accent);\r\n}\r\n.sf-host-item-icon svg { width: 16px; height: 16px; }\r\n.sf-host-item-body { flex: 1; min-width: 0; }\r\n.sf-host-item-name { font-size: 0.85rem; font-weight: 600; color: var(--text-primary); }\r\n.sf-host-item-meta { font-size: 0.72rem; color: var(--text-muted); }\r\n.sf-host-role {\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: rgba(var(--accent-rgb), 0.1);\r\n  color: var(--accent);\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n.sf-host-remove {\r\n  flex: none;\r\n  padding: 4px;\r\n  border: 0;\r\n  border-radius: 6px;\r\n  background: none;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n.sf-host-remove:hover { color: #ef4444; background: rgba(239, 68, 68, 0.1); }\r\n.sf-host-remove svg { width: 14px; height: 14px; }\r\n\r\n.sf-hosts-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 5px;\r\n  margin-top: 12px;\r\n  padding: 24px 18px;\r\n  border: 1px dashed var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  text-align: center;\r\n}\r\n.sf-hosts-empty-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 3px;\r\n  border-radius: 12px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n}\r\n.sf-hosts-empty-icon svg { width: 20px; height: 20px; }\r\n.sf-hosts-empty strong { font-size: 0.86rem; color: var(--text-primary); }\r\n.sf-hosts-empty span { max-width: 420px; font-size: 0.78rem; line-height: 1.4; color: var(--text-muted); }\r\n.sf-hosts-empty .dv-btn { display: inline-flex; align-items: center; gap: 5px; margin-top: 6px; }\r\n.sf-hosts-empty .dv-btn svg { width: 13px; height: 13px; }\r\n\r\n/* Formulario de alta de equipo */\r\n.sf-host-form {\r\n  margin-top: 12px;\r\n  padding: 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-toolbar);\r\n}\r\n.sf-host-form-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n}\r\n.sf-host-form-head > div { display: flex; flex-direction: column; gap: 2px; }\r\n.sf-host-form-head strong { font-size: 0.86rem; color: var(--text-primary); }\r\n.sf-host-form-head span { font-size: 0.74rem; color: var(--text-muted); }\r\n.sf-host-form-close {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px;\r\n  border: 0;\r\n  border-radius: 6px;\r\n  background: none;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n.sf-host-form-close:hover { color: var(--text-primary); background: var(--bg-card); }\r\n.sf-host-form-close svg { width: 15px; height: 15px; }\r\n\r\n.sf-host-form-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(160px, 0.8fr) minmax(220px, 1.2fr) auto;\r\n  gap: 10px;\r\n  align-items: end;\r\n}\r\n@media (max-width: 800px) { .sf-host-form-grid { grid-template-columns: 1fr; } }\r\n.sf-host-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  min-width: 0;\r\n  font-size: 0.74rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n}\r\n.sf-host-field-search { min-width: 0; }\r\n.sf-host-browse-btn { display: inline-flex; align-items: center; gap: 4px; height: 31px; white-space: nowrap; }\r\n.sf-host-browse-btn svg { width: 12px; height: 12px; }\r\n.sf-host-form-hint { margin: 8px 0 0; font-size: 0.72rem; color: var(--text-muted); }\r\n.sf-host-form-actions {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-top: 12px;\r\n}\r\n.sf-host-field-role { width: 220px; max-width: 100%; }\r\n.sf-host-form-buttons { display: flex; gap: 6px; margin-left: auto; }\r\n\r\n/* Selector de equipos del inventario */\r\n.sf-browse-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 2000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: rgba(0, 0, 0, 0.55);\r\n}\r\n.sf-browse-modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 640px;\r\n  max-width: 100%;\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  background: var(--bg-card);\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\r\n}\r\n.sf-browse-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 14px 16px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.sf-browse-head > div { display: flex; flex-direction: column; gap: 2px; }\r\n.sf-browse-head strong { font-size: 0.92rem; color: var(--text-primary); }\r\n.sf-browse-head span { font-size: 0.75rem; color: var(--text-muted); }\r\n.sf-browse-filter { padding: 10px 16px; border-bottom: 1px solid var(--border); }\r\n.sf-browse-list { flex: 1; overflow-y: auto; min-height: 200px; }\r\n.sf-browse-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 11px 16px;\r\n  border: 0;\r\n  border-bottom: 1px solid var(--border);\r\n  background: transparent;\r\n  color: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n.sf-browse-item:hover:not(:disabled) { background: var(--bg-toolbar); }\r\n.sf-browse-item.is-selected { background: rgba(var(--accent-rgb), 0.08); }\r\n.sf-browse-item.is-added { opacity: 0.5; cursor: not-allowed; }\r\n.sf-browse-item-icon { font-size: 1.2rem; }\r\n.sf-browse-item-body { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 0; }\r\n.sf-browse-item-name { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); }\r\n.sf-browse-item-desc { font-size: 0.74rem; color: var(--text-muted); }\r\n.sf-browse-item-added { font-size: 0.72rem; font-weight: 600; color: #16a34a; }\r\n.sf-browse-empty { padding: 30px 20px; text-align: center; font-size: 0.84rem; color: var(--text-muted); }\r\n\r\n.sf-rel-kind {\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n  border: 1px solid var(--border);\r\n  border-radius: 4px;\r\n  padding: 0 5px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Dependencias unificadas: necesita vs impacto ───────────────────────── */\r\n.sf-dep-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 12px;\r\n}\r\n.sf-dep-lead {\r\n  max-width: 760px;\r\n  margin: 4px 0 0;\r\n  font-size: 0.8rem;\r\n  line-height: 1.45;\r\n  color: var(--text-muted);\r\n}\r\n.sf-dep-head-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\r\n\r\n.sf-dep-summary {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 10px;\r\n  margin-bottom: 16px;\r\n}\r\n.sf-dep-summary-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  padding: 10px 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n}\r\n.sf-dep-summary-card span {\r\n  font-size: 0.67rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-muted);\r\n}\r\n.sf-dep-summary-card strong { font-size: 1.15rem; color: var(--text-primary); }\r\n.sf-dep-summary-need strong { color: #f59e0b; }\r\n.sf-dep-summary-impact strong { color: #a78bfa; }\r\n\r\n.sf-dep-form {\r\n  margin-bottom: 16px;\r\n  padding: 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-toolbar);\r\n}\r\n.sf-dep-form-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n}\r\n.sf-dep-form-head > div { display: flex; flex-direction: column; gap: 2px; }\r\n.sf-dep-form-head strong { font-size: 0.86rem; color: var(--text-primary); }\r\n.sf-dep-form-head span { font-size: 0.74rem; color: var(--text-muted); }\r\n.sf-dep-form-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(150px, 0.9fr) minmax(220px, 1.4fr) minmax(120px, 0.6fr);\r\n  gap: 10px;\r\n  align-items: end;\r\n}\r\n@media (max-width: 900px) { .sf-dep-form-grid { grid-template-columns: 1fr; } }\r\n.sf-dep-form-notes { margin-top: 10px; }\r\n.sf-dep-form-actions { display: flex; gap: 6px; margin-top: 12px; }\r\n\r\n.sf-dep-columns {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 16px;\r\n}\r\n@media (max-width: 900px) { .sf-dep-columns { grid-template-columns: 1fr; } }\r\n.sf-dep-column {\r\n  min-width: 0;\r\n  padding: 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n}\r\n.sf-dep-col-head { display: flex; align-items: center; gap: 8px; }\r\n.sf-dep-col-head strong { font-size: 0.88rem; color: var(--text-primary); }\r\n.sf-dep-col-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  flex: none;\r\n  border-radius: 50%;\r\n  background: #f59e0b;\r\n}\r\n.sf-dep-column-impact .sf-dep-col-dot { background: #a78bfa; }\r\n.sf-dep-col-count {\r\n  margin-left: auto;\r\n  padding: 1px 8px;\r\n  border-radius: 999px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n}\r\n.sf-dep-col-sub { margin: 2px 0 10px; font-size: 0.75rem; color: var(--text-muted); }\r\n\r\n.sf-dep-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 9px;\r\n  margin-top: 7px;\r\n  padding: 9px 10px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 9px;\r\n  background: var(--bg-card);\r\n}\r\n.sf-dep-row-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  flex: none;\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  font-size: 15px;\r\n}\r\n.sf-dep-row-body { flex: 1; min-width: 0; }\r\n.sf-dep-row-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n.sf-dep-link {\r\n  padding: 0;\r\n  border: 0;\r\n  background: none;\r\n  color: var(--accent);\r\n  font: inherit;\r\n  font-weight: 700;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n.sf-dep-link:hover { text-decoration: underline; }\r\n.sf-dep-source {\r\n  padding: 1px 6px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  color: var(--text-muted);\r\n  font-size: 0.63rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n.sf-dep-source.is-model { color: #a78bfa; border-color: rgba(139, 92, 246, 0.4); }\r\n.sf-dep-row-meta {\r\n  display: flex;\r\n  align-items: baseline;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  margin-top: 3px;\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n}\r\n.sf-dep-note {\r\n  max-width: 280px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-style: italic;\r\n}\r\n.sf-dep-empty {\r\n  margin-top: 8px;\r\n  padding: 16px 12px;\r\n  border: 1px dashed var(--border);\r\n  border-radius: 9px;\r\n  color: var(--text-muted);\r\n  font-size: 0.78rem;\r\n  text-align: center;\r\n}\r\n.sf-dep-remove {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: none;\r\n  padding: 4px;\r\n  border: 0;\r\n  border-radius: 6px;\r\n  background: none;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n.sf-dep-remove:hover { color: #ef4444; background: rgba(239, 68, 68, 0.1); }\r\n.sf-dep-remove svg { width: 14px; height: 14px; }\r\n.sf-dep-footnote { margin: 10px 0 0; font-size: 0.72rem; color: var(--text-muted); }\r\n\r\n/* ── Elementos del servicio (miembros del Disenador) ────────────────────────\r\n   Lista de CIs que forman el servicio con su papel, para no depender del canvas. */\r\n#sf-elementos-servicio {\r\n  border-left: 3px solid var(--accent);\r\n}\r\n\r\n.sf-el-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.sf-el-row {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  padding: 4px 0;\r\n  border-bottom: 1px dashed var(--border);\r\n}\r\n\r\n.sf-el-row:last-child { border-bottom: none; }\r\n\r\n.sf-el-name {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  font-size: 0.82rem;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n}\r\n\r\n.sf-el-detail {\r\n  font-size: 0.74rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sf-el-role {\r\n  flex: 0 0 auto;\r\n  font-size: 0.7rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  color: var(--accent);\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 1px 8px;\r\n  white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
